import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Instructions from "./instructions";
import usePermission from "hooks/usePermission";
import { getSettings, updateBuyEnergySettings, updatePaymentSettings } from "store/actions";
import LoadingButton from "../../../components/shared/LoadingButton";

const BuyEnergySetting = () => {
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);
  const { hasPermission } = usePermission();
  const permissions = {
    add: false,
    edit: hasPermission("edit_buy_energy_setting"),
    delete: false,
  };

  const [fields, setFields] = useState({
    bitanicaPayCardStatus: "disabled",
    bitanicaPayCryptoStatus: "disabled",
    cardStatus: "disabled",
    btncCoinStatus: "enabled",
    cryptoStatus: "disabled",
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings?._id) {
      const buyEnergy = settings?.buyEnergy;
      setFields(() => ({
        bitanicaPayCardStatus: buyEnergy?.bitanicaPayCardStatus,
        bitanicaPayCryptoStatus: buyEnergy?.bitanicaPayCryptoStatus,
        cardStatus: buyEnergy?.cardStatus,
        btncCoinStatus: buyEnergy?.btncCoinStatus,
        cryptoStatus: buyEnergy?.cryptoStatus,
        
      }));
    }
  }, [settings]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFields((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submit = async () => {
    dispatch(
      updateBuyEnergySettings({
        data: { ...fields },
      }),
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <Col lg={8}>
                    <Instructions />
                  </Col>

                  <Col lg={8}>
                    <Row>
                  
  <Col md={6}>
                        <FormGroup>
                          <Label>Bitanica Pay Card Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="bitanicaPayCardStatus"
                            className="form-control"
                            value={fields?.bitanicaPayCardStatus}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Bitanica Pay Crypto Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="bitanicaPayCryptoStatus"
                            className="form-control"
                            value={fields?.bitanicaPayCryptoStatus}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>
                       <Col md={6}>
                        <FormGroup>
                          <Label>Card Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="cardStatus"
                            className="form-control"
                            value={fields?.cardStatus}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>
                       <Col md={6}>
                        <FormGroup>
                          <Label>BTNC Coin Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="btncCoinStatus"
                            className="form-control"
                            value={fields?.btncCoinStatus}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>
                        <Col md={6}>
                        <FormGroup>
                          <Label>Crypto Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="cryptoStatus"
                            className="form-control"
                            value={fields?.cryptoStatus}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>

                      <Col md={6} />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end mt-3">
                          <LoadingButton
                            onClick={submit}
                            className="btn btn-primary btn-lg"
                            loading={loading}
                            disabled={loading}
                          >
                            {!loading ? <>Save Changes</> : ""}
                          </LoadingButton>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BuyEnergySetting;
